export default __webpack_public_path__ + "static/media/card1.a3106908.png";